import { Pipe, PipeTransform } from '@angular/core';
import { SharedConstants } from '@app/eds';
import { ObjectUtil } from '../utils';

@Pipe({ name: 'queryValue' })
export class QueryValuePipe implements PipeTransform {
  transform(
    value: any,
    property: string,
    defaultValue: string = SharedConstants.EMPTY_STRING
  ): string {
    if (!value) {
      return defaultValue;
    }

    if (!property) {
      return value.toString();
    }

    const _value = ObjectUtil.queryValue(value, property);

    if (!_value) {
      return defaultValue;
    }

    return _value.toString();
  }
}
